/**
 * Created by jpilz on 2/13/17.
 */
"use strict";
import {context} from '../../objects/context.js';
import ko from 'knockout';

class jobTemplateModel {

    constructor(params) {
        // Profile
        this.componentName = ko.observable("header");
        this.context = context;
        this.id = this.context.util.guid();
        this.visible = ko.observable(true);

        this.contentVisible = ko.observable(false);
        
    }
        
    toggleContent() {
        this.contentVisible(!this.contentVisible());
    }

}

export default { viewModel: jobTemplateModel, template: require('!raw-loader!./jobDefaultTemplate.html') };


// WEBPACK FOOTER //
// ./src/components/jobDefaultTemplate/jobDefaultTemplate.js